<template>
  <section>
    <div class="searchBar">
      <!-- <div class="box-ui-check searchbar-content mr-5">
        <div class="title">
          <span>날짜</span> :
        </div>
        <date-selector :class="'searchbar-content'" @setStartDate="setStartDate" @setEndDate="setEndDate" :startDefault="startDefault" :endDefault="endDefault" :configs="dateConfigs" />
      </div> -->
      <div class="box-ui-check searchbar-content mr-5">
        <div class="title"><span>검색기준</span> :</div>
        <select v-model="searchOptions.type" @change="searchTypeChange">
          <option value="">전체</option>
          <option value="siteId">아이디</option>
          <option value="siteName">회사명</option>
          <option value="doamin">도메인</option>
          <option value="idx">고유번호</option>
        </select>
      </div>
      <input type="text" placeholder="검색어 입력" v-model="searchOptions.text" />
      <button class="btn-search" type="button" @click="pageSeach">
        검색
      </button>
    </div>
    <div class="main-contents-wrapper">
      <article class="total-info-container fx-col-sbw">
        <div class="total-info-wrap">
          <div class="total-info-item">
            <img :src="require('@/assets/img/searchicon.png')" />
            검색
            <span>검색결과</span>
          </div>
          <div class="total-info-item">
            <span class="title">{{ $t(`totalInfo.tatal_list_count`) }}</span> : <span class="value">{{ pageInfo.tatal_list_count }}</span>
          </div>
          <div class="total-info-item">
            <span class="title">{{ $t(`totalInfo.page`) }}</span> : <span class="value">{{ pageInfo.page }}</span>
          </div>
          <div class="total-info-item">
            <span class="title">{{ $t(`totalInfo.tatal_page_count`) }}</span> : <span class="value">{{ pageInfo.tatal_page_count }}</span>
          </div>
        </div>
      </article>
      <div class="table-wrapper">
        <table class="mainTable">
          <table-head :headInfo="headInfo" />
          <tbody>
            <template v-if="dataLength !== 0">
              <tr v-for="(item, idx) in tableData" :key="item.ip">
                <td>{{ idx + 1 }}</td>
                <td>
                  <button type="button" class="fc-id btn-link" @click="openDetail(item.memid)">{{ item.memid }}</button>
                </td>
                <td>{{ item.memName }}</td>
                <!-- <td>{{ item.domain }}</td> -->
                <td>{{ item.belongCnt }}</td>
                <td>{{ item.ptFeeAmt }}</td>
                <td>{{ item.cashAmt }}</td>
                <td>{{ item.pointAmt }}</td>
                <!-- <td style="width: 6%">
                  <ui-toggle :textType="'default'" :checked="true" @setYn="setSiteYn(item)"/>
                </td> -->
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
    <pagination v-if="tableData.length !== 0" @goPage="goPage" :pageNum="pageInfo.page" :pageSize="pageInfo.count_per_list" :totalCount="pageInfo.tatal_list_count" />
  </section>
</template>

<script>
import lodash from "lodash";
import TableHead from "@/components/main/table/Head";
import uiToggle from "@/components/ui/UiToggle";
import Pagination from "@/components/common/Pagination";
import { companyStatistics,companyOptionSave } from "@/api/company";
import { replceDateT, numberWithCommas, getDateStr } from "@/libs/utils.js";
export default {
  name: "Control",
  components: {
    TableHead,
    uiToggle,
    Pagination
  },
  data: function () {
    return {
      tableName: this.$route.name,
      headInfo: {
        fstColumn: false,
        dataList: ["index", "id", "companyName","userCnt", "credit", "cashAmt", "pointAmt"]
      },
      pageInfo: {
        tatal_list_count: 0,
        page: 0,
        tatal_page_count: 0
      },
      reqData: {
        memId: "",
        memName: "",
        domain: "",
        startDate: "",
        endDate: "",
        partnerType:"",
        page: 1,
        tatal_list_count: 30
      },
      tableData: [],
      searchOptions: {
        type: "",
        text: ""
      }
    };
  },
  methods: {
    async goPage(page){
      console.log(page)
      await this.setTableData(page);
    },
    openDetail(siteId) {
      // console.log(memId);
      const routeData = this.$router.resolve({ name: "Detail", query: { id: siteId } });
      window.open(routeData.href, "newpage", "top=0,left=150,scrollbars=no,resizable=no,width=1435,height=825,status=no");
    },
    getSiteInfo() {
      const siteInfoCookie = getSiteData();
      if (siteInfoCookie) {
        const siteInfo = JSON.parse(siteInfoCookie);
        return siteInfo;
      }
    },
    async getStaticsList() {
      const req = lodash.cloneDeep(this.reqData);
      const res = await companyStatistics(req);
      return res.data;
    },
    async setTableData(page) {
      this.reqData.page = page;
      const data = await this.getStaticsList();
      // console.log(data)
      const list = data.list;
      if(!list) return;
      if (list.length !== 0) {
        for (const item of list) {
          for (const key in item) {
            if (key.indexOf("Amt") > -1) {
              item[key] = numberWithCommas(Number(item[key]));
            }
          }
        }
        // console.log(list)
        this.tableData = list;
        this.dataLength = this.tableData.length;
        this.pageInfo = data.pageInfo;
        this.pageInfo.tatal_list_count = numberWithCommas(this.pageInfo.tatal_list_count);
        this.pageInfo.tatal_page_count = numberWithCommas(Number(this.pageInfo.tatal_page_count) + 1);
      }
    }
  },
  async created() {
    await this.setTableData(1);
  }
};
</script>

<style scoped>
.sub-title {
  font-size: 1em;
  font-weight: 700;
  color: var(--main);
  height: 32px;
  position: relative;
  margin-bottom: 20px;
  border-bottom: 2px solid var(--main);
}
.sub-title > h3 {
  display: flex;
  height: 100%;
  align-items: center;
  width: 180px;
  font-size: 0.9em;
  border-start-end-radius: 10px;
  border-start-start-radius: 10px;
}
.sub-title > h3::before {
  content: "●";
  color: #18698b;
  margin-right: 7px;
}
textarea {
  width: 100%;
  min-height: 160px;
  border: 1px solid #18698b;
  resize: none;
  box-sizing: border-box;
  padding: 10px;
  border-radius: 3px;
}
.toggle-wrap {
  width: auto;
  justify-content: center;
}
.pt50 {
  padding-top: 50px;
}
.modal-wrapper {
  display: flex;
  font-size: 16px;
}
.item-wrap > div.item-title {
  min-width: 100px;
}
.item-content > select {
  width: 183px;
}
</style>
